import React from 'react'
import { Table, Tag, Space, Button, Tooltip } from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import type { ColumnsType } from 'antd/es/table'
import type { Role } from '../types/role.types'

interface RolesTableProps {
    roles: Role[]
    onEdit: (role: Role) => void
    onDelete: (role: Role) => void
}

export const RolesTable: React.FC<RolesTableProps> = ({ roles, onEdit, onDelete }) => {
    const columns: ColumnsType<Role> = [
        {
            title: 'Role Name',
            dataIndex: 'display_name',
            key: 'display_name',
            render: (text: string, record: Role) => (
                <Space>
                    <strong>{text}</strong>
                    {record.is_system && (
                        <Tag color="blue">System Role</Tag>
                    )}
                </Space>
            ),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Permissions',
            dataIndex: 'permissions_count',
            key: 'permissions_count',
            align: 'center',
            render: (count: number) => <Tag color="green">{count} permissions</Tag>,
        },
        {
            title: 'Users',
            dataIndex: 'users_count',
            key: 'users_count',
            align: 'center',
            render: (count: number) => <Tag color="blue">{count} users</Tag>,
        },
        {
            title: 'Created',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (date: string) => new Date(date).toLocaleDateString(),
        },
        {
            title: 'Actions',
            key: 'actions',
            align: 'center',
            render: (_: any, record: Role) => (
                <Space>
                    <Tooltip title="Edit Role">
                        <Button
                            type="link"
                            icon={<EditOutlined />}
                            onClick={() => onEdit(record)}
                        />
                    </Tooltip>
                    <Tooltip title={record.is_system ? "System roles cannot be deleted" : "Delete Role"}>
                        <Button
                            type="link"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => onDelete(record)}
                            disabled={record.is_system}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ]

    return (
        <Table
            columns={columns}
            dataSource={roles}
            rowKey="id"
            pagination={{
                pageSize: 10,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} roles`,
            }}
        />
    )
}
